import React from 'react'
import EditTourPackageWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import TourPackageForm from '../components/form/form.component'
import TourPackageImages from '../components/images/images.component'
import FormHelper from '../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditTourPackage extends React.Component {

    constructor(props) {
        super(props)
        this.editTourPackageWorker = EditTourPackageWorker(this)
        this.state = this.editTourPackageWorker.getDefaultState()
    }

    componentDidMount(){
        this.editTourPackageWorker.loadTourPackage()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editTourPackageWorker.isValid() && this.editTourPackageWorker.updateTourPackage()
    }

    onCancel = () => this.props.history.push('/content/tour-packages')

    render() {
        return (
            <div className="edit-tour-package">
                {
                    (this.state.loadingTourPackage || this.state.updatingTourPackage) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/tour-packages">Tour Packages</Link>
                    <div className="header">
                        <h4>Edit Tour Package</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <TourPackageForm {...this.state} action="Save Tour Package" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <TourPackageImages tourPackageId={this.state.id} images={this.state.images} />
                    </TourPackageForm>
                </div>
            </div>
        )
    }
}

export default withRouter(EditTourPackage)
